import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';


const firebaseConfig = {
  apiKey: "AIzaSyC8OEJmCr8LVZ3dWkF9BJPIJGAD4P9Hwgk",
  authDomain: "personalaccounting-9e05a.firebaseapp.com",
  projectId: "personalaccounting-9e05a",
  storageBucket: "personalaccounting-9e05a.firebasestorage.app",
  messagingSenderId: "1057771744119",
  appId: "1:1057771744119:web:0dbce8f74736b55ff3cf72",
  measurementId: "G-NDE98HFKLV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

// Enable offline persistence
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.log('Persistence failed: Multiple tabs open');
  } else if (err.code === 'unimplemented') {
    console.log('Persistence not available');
  }
});